import moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dayOfWeek'
})
export class DayOfWeekPipe implements PipeTransform {
  private _dateFormat = 'MMMM Do';
  private _dayFormat  = 'dddd';

  transform( date : string, format : 'date' | 'day' = 'day' ) : string {
    return moment(date)
      .format(format === 'date' ? this._dateFormat : this._dayFormat);
  }
}
